var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"mt-4",attrs:{"justify":"center","align":"center"}},[_c('v-col',{attrs:{"cols":"1"}},[_c('v-progress-circular',{attrs:{"color":"primary","indeterminate":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }